export { default } from "./Typography.mjs";
export { default as typographyClasses } from "./typographyClasses.mjs";
export * from "./typographyClasses.mjs";